module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Fb-Gb-Hc-Ia-outside.70cc02ae.png";